// export const BASE_URL = "http://10.0.101.125:7071";
// export const BASE_URL = "https://simpegbackend.klikthb.com";
// export const BASE_URL = process.env.VUE_APP_API_BASE_URL;

const isProduction =
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1";

export const BASE_URL = isProduction
  ? "https://simpegbackend.klikthb.com"
  : "http://localhost:7071";

export const API_BASE_URL = `${BASE_URL}/api`;
export const ODATA_BASE_URL = `${BASE_URL}/odata`;
// export const API_BASE_URL = "http://localhost:7071/api";
// export const ODATA_BASE_URL = `${BASE_URL}/odata`;
